import { render, staticRenderFns } from "./AssetLayoutSwitcher.vue?vue&type=template&id=5be0ae85&"
import script from "./AssetLayoutSwitcher.vue?vue&type=script&lang=js&"
export * from "./AssetLayoutSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports